import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
// import 'firebase/firestore'
// import 'firebase/analytics'
import firebaseConfig from './firebaseConfig'
export const firebaseApp = initializeApp(firebaseConfig)
// export const db = firebaseApp.firestore()
export const db = getFirestore(firebaseApp)
// firebase.analytics();
